export var UsageEventName;
(function (UsageEventName) {
    UsageEventName["ButtonClicked"] = "ButtonClicked";
    UsageEventName["BackEndAPICall"] = "BackEndAPICall";
    UsageEventName["PageLoad"] = "PageLoad";
    UsageEventName["PanelOpened"] = "PanelOpened";
    UsageEventName["PanelClosed"] = "PanelClosed";
    UsageEventName["CardAdded"] = "CardAdded";
    UsageEventName["CardDeleted"] = "CardDeleted";
    UsageEventName["CardResized"] = "CardResized";
    UsageEventName["DatePickerDismissed"] = "DatePickerDismissed";
    UsageEventName["CalendarMonthViewClicked"] = "CalendarMonthViewClicked";
    UsageEventName["CalendarDayViewClicked"] = "CalendarDayViewClicked";
    UsageEventName["CalendarClearButtonClicked"] = "CalendarClearButtonClicked";
    UsageEventName["CalendarGoToTodayButtonClicked"] = "CalendarGoToTodayButtonClicked";
    UsageEventName["CalendarDateClicked"] = "CalendarDateClicked";
    UsageEventName["CalendarMonthClicked"] = "CalendarMonthClicked";
    UsageEventName["CalendarNextButtonClicked"] = "CalendarNextButtonClicked";
    UsageEventName["CalendarPrevButtonClicked"] = "CalendarPrevButtonClicked";
    UsageEventName["ViewActivated"] = "ViewActivated";
    UsageEventName["ViewDeactivated"] = "ViewDeactivated";
    UsageEventName["MarkerSelected"] = "MarkerSelected";
    UsageEventName["ListSelected"] = "ListSelected";
    UsageEventName["LinkClicked"] = "LinkClicked";
    UsageEventName["DatePickerClicked"] = "DatePickerClicked";
    UsageEventName["DatePickerDateSelected"] = "DatePickerDateSelected";
    UsageEventName["DatePickerFocused"] = "DatePickerDateSelected";
    UsageEventName["ViewPhoto"] = "ViewPhoto";
    UsageEventName["TabSelected"] = "TabSelected";
    UsageEventName["DropdownSelected"] = "DropdownSelected";
    UsageEventName["DropdownFocused"] = "DropdownFocused";
    UsageEventName["CheckBoxChanged"] = "CheckBoxChanged";
    UsageEventName["CheckBoxFocused"] = "CheckBoxFocused";
    UsageEventName["RadioButtonChanged"] = "RadioButtonChanged";
    UsageEventName["RadioButtonFocused"] = "RadioButtonFocused";
    UsageEventName["TextChanged"] = "TextChanged";
    UsageEventName["TextboxFocused"] = "TextboxFocused";
    UsageEventName["OnFocus"] = "OnFocus";
    UsageEventName["OnBlur"] = "OnBlur";
    UsageEventName["TileLoaded"] = "TileLoaded";
    UsageEventName["MobileRefresh"] = "MobileRefresh";
})(UsageEventName || (UsageEventName = {}));
//# sourceMappingURL=UsageEventName.js.map